var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"epic-search-tab-nav hvr-overline-reveal",style:(_vm.eActive ? _vm.activeStyle : _vm.style),on:{"click":_vm.onClick}},[_vm._t("default",[_vm._v("Label")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }